import _ from "lodash";
import { SkogsvardAtgardsGrupp } from "~app/common/models/constants";
import { IVKAtgardKedjaKoppling } from "~app/features/virkeskop/models/Atgardskedjor/atgardskedjor-models";
import { AtgardStatuses } from "~app/features/virkeskop/models/atgardstatus/atgardstatuses-models";
import { KontraktMediatorService } from "~app/features/virkeskop/services/kontrakt-mediator.service";
import { NavigationService } from "~app/features/virkeskop/services/navigation.service";
import { AtgardStatusBase, IAtgardStatus, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class RelateradAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "Åtgärdskedja";
    tooltips: IAtgardStatusTooltip[];

    icons = [
        {
            visible: true,
            iconclass1: "far fa-link",
            incomplete: false,
            warning: false,
            customTriggers: "raskDefault"
        }
    ];

    constructor(
        model: AtgardStatuses,
        private readonly navigationService: NavigationService,
        private readonly atgardKedjaKopplingar: IVKAtgardKedjaKoppling[],
        private readonly kontraktMediatorService: KontraktMediatorService
    ) {
        super(model);
        this.tooltips = this.createKedjansTooltips();
        if (this.atgardKedjaKopplingar) {
            const kedjeGuid = this.atgardKedjaKopplingar[0].kedjaGuid;
            this.addKedjeHandlerToTooltips(kedjeGuid);
        }
    }

    visible(): boolean {
        return this.atgardKedjaKopplingar?.length > 1;
    }

    private openThis(kedjeGuid: string) {
        this.kontraktMediatorService.openAtgardKedjeHandlerDialog(kedjeGuid);
    }

    private openCopyAtgardGeometry(kedjeGuid: string) {
        this.kontraktMediatorService.openAtgardKedjeCopyGeometryDialog(kedjeGuid);
    }

    private navigateTo(kedjaKoppling: IVKAtgardKedjaKoppling, event: Event) {
        const {
            avtalId, kontraktId, atgardId
        } = kedjaKoppling;
        const {
            avtalId$: avtalId$, kontraktId$: kontraktId$, atgardId$: atgardId$
        } = this.navigationService;

        if(avtalId !== avtalId$.value
            || kontraktId !== kontraktId$.value
            || atgardId !== atgardId$.value
        ) {
            // om någon parameter har ändrats hanteras navigering av queryParams subscription i avtalskomponenten
            return;
        }

        event.preventDefault();
        avtalId$.next(avtalId);
        kontraktId$.next(kontraktId);
        atgardId$.next(atgardId);
    }

    private createKedjansTooltips(): IAtgardStatusTooltip[] {
        const tooltips: IAtgardStatusTooltip[] = [];
        const avtalId$ = this.navigationService.avtalId$;

        this.atgardKedjaKopplingar?.forEach(kedjaKoppling => {
            const avtalId = kedjaKoppling.avtalId;
            let linkTarget = "_self";
            const boldflag = this.status.atgardGUID === kedjaKoppling.atgardGuid;
            let textRoute = kedjaKoppling.beteckning;

            if (_.isNil(kedjaKoppling.atgardId)) {
                textRoute = `Ny ${ textRoute}`;
            }

            if(avtalId !== avtalId$.value) {
                textRoute = `${textRoute } (ny flik) `;
                linkTarget = "_blank";
            }

            tooltips.push({
                header: SkogsvardAtgardsGrupp.rojning === kedjaKoppling.atgardsgrupp ? kedjaKoppling.atgardstyp : kedjaKoppling.atgardsgrupp,
                routeText: textRoute,
                text: "",
                bold: boldflag,
                visible: true,
                link: kedjaKoppling.atgardId != null ? {
                    route: [
                        "/virkeskop/avtal",
                        kedjaKoppling.avtalId
                    ],
                    queryParams: { kontraktId: kedjaKoppling.kontraktId,
                        atgardId: kedjaKoppling.atgardId },
                    target: linkTarget,
                    onClick: event => this.navigateTo(kedjaKoppling, event)
                } : null
            });
        });

        return tooltips;
    }

    private addKedjeHandlerToTooltips(kedjeGuid: string) {
        this.tooltips.push({
            header: "",
            routeText: "Justera åtgärdskedja",
            hideWhenDirty: true,
            text: "",
            bold: false,
            visible: true,
            link:{
                route: "",
                onClick: () => this.openThis(kedjeGuid)
            }
        });

        this.tooltips.push({
            header: "",
            routeText: "Kopiera åtgärdsgeometri",
            hideWhenDirty: true,
            text: "",
            bold: false,
            visible: true,
            link:{
                route: "",
                onClick: () => this.openCopyAtgardGeometry(kedjeGuid)
            }
        });
    }
}
